import { CssBaseline, StyledEngineProvider } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';

// routing
import Routes from 'routes';

// defaultTheme
import themes from 'themes';

// project imports
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from 'context/AuthContext';
import { ContextProvider, useStateContext } from 'context/ContextProvider';
import NavigationScroll from 'layout/NavigationScroll';
import { SnackbarProvider } from 'notistack';

// ==============================|| APP ||============================== //

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 1,
            staleTime: 30000,
            refetchOnWindowFocus: false,
            onError: (error) => {
                if (error.response?.status === 401) {
                    window.location.href = '/pages/login/login3';
                }
            }
        }
    }
});

const App = () => {
    const customization = useStateContext();

    return (
        <QueryClientProvider client={queryClient}>
            <StyledEngineProvider injectFirst>
                <AuthProvider>
                    <ContextProvider>
                        <ThemeProvider theme={themes(customization)}>
                            <SnackbarProvider
                                maxSnack={4}
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                autoHideDuration={3500}
                            >
                                <CssBaseline />
                                <NavigationScroll>
                                    <Routes />
                                </NavigationScroll>
                            </SnackbarProvider>
                        </ThemeProvider>
                    </ContextProvider>
                </AuthProvider>
            </StyledEngineProvider>
        </QueryClientProvider>
    );
};

export default App;
